<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-billing_address_country"
      type="select"
      @change="inputChange"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      :rules="required ? 'required' : ''"
      :options="countryOptions"
    />
  </div>
</template>

<script>
import BaseInputMixin from "../../../../mixins/profileInputMixin";
import {mapGetters, mapMutations} from "vuex";
import InputWidget from "../../../core/InputWidget";

export default {
  name: "ShippingCountry",
  components: {InputWidget},
  mixins: [BaseInputMixin('shipping_address.country_code')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'shipping_address.country_code',
      defaultLabel: this.$t("Country",)
    }
  },
  computed: {
    ...mapGetters(['countryOptions'])
  },
  methods: {
    ...mapMutations(['profileFieldOnInput']),
    inputChange(val) {
      this.profileFieldOnInput({field: this.name, value: val})
    }
  }
}
</script>

<style scoped>

</style>
